export default interface SINGLE_SIGN_ON
{
	instance                      : string;
	tenant                        : string;
	clientId                      : string;
	mobileId                      : string;
	mobileRedirectUrl             : string;
	endpoints                     : any;
}

